import FaceUSBTokenActivateWarning from './FaceUSBTokenActivateWarning';

export default FaceUSBTokenActivateWarning;
